import { Profile } from "./types/profile.type";

export const transformProfileData = (profile: Profile) => {
  return {
    id: profile.id,
    name: profile.name,
    riskRating: profile.riskRating,
    status: profile.status,
    assignedToId: profile.assignedToId,
    assignedTo: profile.assignedTo,
    modifiedAt: profile.modifiedAt,
    isSelected: false,
    kycApprovedAt: profile.kycApprovedAt,
    kycReviewOn: profile.kycReviewOn,
    type: profile.type,
    internalId: profile.internalId,
    customerId: profile.customerId,
    safeNumber: profile.safeNumber,
    organisationNumber: profile.organisationNumber,
    createdAt: profile.createdAt,
    createdById: profile.createdById,
    createdBy: profile.createdBy,
    modifiedById: profile.modifiedById,
    modifiedByUsername: profile.modifiedByUsername,
    isLocked: profile.isLocked,
    modeOfCreation: profile.modeOfCreation,
  } as Profile;
};

export const transformProfilesArray = (profiles: Profile[]) => {
  return (
    profiles &&
    profiles.map((profile: Profile) => transformProfileData(profile))
  );
};
